import CommonService from '@/services/CommonService';
const BASE_URI = 'user'

export const printUserTitle = (user) => {
  return user.title ?? user.userGroup.name
}
export const printFullName = (user) => {
  return user.firstName ? (user.firstName + ' ' + user.lastName) : user.email
}
export default {
  list (params = '') {
    return $api(`${BASE_URI}/?${params}`)
  },

  get (id) {
    return $api(`${BASE_URI}/get/${id}`)
  },
  add (entity) {
    return $api(`${BASE_URI}/add`, {
      method: 'POST',
      body: CommonService.formData(entity),
      loading: true
    })
  },
  
  update (entity) {
    return $api(`${BASE_URI}/update`, {
      method: 'POST',
      body: CommonService.formData(entity),
      loading: true
    })
  },

  delete (id) {
    return $api(`${BASE_URI}/delete/${id}`, {method: 'DELETE', loading: true})
  },

  profile (entity) {
    return $api(`${BASE_URI}/profile`, {
      method: 'POST',
      body: CommonService.formData(entity),
      loading: true
    })
  },
  ping () {
    return $api(`${BASE_URI}/ping`)
  },
  viewPage (page) {
    return $api(`${BASE_URI}/view-page/${page}`)
  },
  testSmtp () {
    return $api(`${BASE_URI}/test-smtp`, {
      method: 'POST',
      loading: true,
      noPushMessage: true
    })
  },
  getNotifications (page) {
    return $api(`${BASE_URI}/get-notifications/${page}`)
  },
}
